import React, { useState } from "react";
import Spinner from "../../../../../common/spinner";
import { useSelector } from "react-redux";
import apiCall from "../../../../../../apicall";

const ConfirmationDeleteJobType = ({ jobId, getJobType, setErrSuccessMsg }) => {
  const { TOKEN } = useSelector((state) => state.menu);
  const [isLoading, setIsLoading] = useState(false);
  const [isJobDeteleted, setIsJobDeteleted] = useState(false);
  console.log("jobIdjobIdjobIdjobIdjobId", jobId)

  const displayErrMsg = (errMsg) => {
    setErrSuccessMsg({
      message: errMsg,
      status: false,
    });
    setIsLoading(false);
    setIsJobDeteleted(false);
  };

  const handleJobTypeDelete = async () => {
    try {
      setIsLoading(true);
      const deleteJobResponse = await apiCall(
        `openstaff/jobs/${jobId}/deleteJobType`,
        "PUT",
        null,
        TOKEN
      );
      console.log("deleteJobResponse----", deleteJobResponse);
      if (deleteJobResponse?.status === 200) {
        setIsLoading(false);
        setIsJobDeteleted(true);
        const modalElement = document.getElementById('delete_job_type_popup');
        if (modalElement) {
          const modal = window.bootstrap.Modal.getInstance(modalElement);
          if (modal) {
            modal.hide();
          }
        }

        setErrSuccessMsg({
          message: "Profession has been disabled!",
          status: true,
        });

        setTimeout(() => {
          getJobType();
        }, 1000);
      } else if (deleteJobResponse?.response?.status == 401) {
        displayErrMsg("Your session has been expired!");
      } else {
        displayErrMsg(deleteJobResponse?.response?.data?.message);
      }
    } catch (err) {
      console.log("setSessionExpired--", err);
      displayErrMsg("Something went wrong!");
    }
  };

  return (
    <div
      className="modal fade twm-sign-up"
      id="delete_job_type_popup"
      aria-hidden="true"
      aria-labelledby="deleteJobTypePopupLabel"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex={-1}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h2 className="modal-title" id="deleteJobTypePopupLabel">
              Are you sure you want to disable this profession?
            </h2>
            <p>It will no longer be selectable for job seekers or job posters but can be reenabled later.</p>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => setIsJobDeteleted(false)}
            />
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-danger"
              data-bs-dismiss="modal"
              onClick={() => setIsJobDeteleted(false)}
            >
              No
            </button>
            <>
              <button
                type="button"
                id="deleteConfirmationModal"
                className="btn btn-success"
                onClick={handleJobTypeDelete}
              >
                {isLoading ? <Spinner /> : "Yes"}
              </button>
            </>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationDeleteJobType;